<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/CA-logo.jpeg" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/images/CA-logo.jpeg" alt="" height="17">
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/CA-logo.jpeg" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/images/CA-logo.jpeg" alt="" height="40">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

    </div>

    <div class="d-flex">

      <div class="attendance-widget mt-3" *ngIf="isEmployee">
        <span class="attendance-timer" *ngIf="isCheckedIn">{{ attendanceElapsedTime }}</span>
        <button
          type="button"
          class="btn attendance-action-btn"
          [ngClass]="isCheckedIn ? 'btn-danger' : 'btn-success'"
          [disabled]="isAttendanceSubmitting"
          (click)="handleAttendanceAction()">
          {{ isAttendanceSubmitting ? (isCheckedIn ? 'Checking Out...' : 'Checking In...') : (isCheckedIn ? 'Check-Out' : 'Check-In') }}
        </button>
      </div>

      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
          <img class="rounded-circle header-profile-user" src="assets/images/users/avatar1.png" alt="Header Avatar">
          <span class="d-none d-xl-inline-block ms-1">{{_userName}}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a class="dropdown-item" routerLink="/contacts/profile"><i class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.PROFILE' | translate}}</a>
          
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ 'HEADER.LOGIN.LOGOUT' | translate}}</a>
        </div>
      </div>

    </div>
  </div>
</header>
